import { Directive, ElementRef, AfterViewInit, NgZone } from '@angular/core';
import { setting } from '../../../../setting';

// Se calcula una sola vez: la directiva se instancia por cada <img src> de la app
// y `setting` no cambia en runtime.
function collectHttpUrls(obj: any, urls: string[] = []): string[] {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      if (typeof value === 'string' && value.startsWith('http://')) {
        const baseUrl = value.split('/api')[0];
        if (!urls.includes(baseUrl)) {
          urls.push(baseUrl);
        }
      } else if (typeof value === 'object' && value !== null) {
        collectHttpUrls(value, urls);
      }
    }
  }
  return urls;
}

const HTTP_ONLY_URLS: string[] = collectHttpUrls(setting);

@Directive({
  selector: 'img[src]'
})
export class SecureImageDirective implements AfterViewInit {

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  private shouldKeepHttp(url: string): boolean {
    return HTTP_ONLY_URLS.some(httpUrl => url.startsWith(httpUrl));
  }

  ngAfterViewInit() {
    // Fuera de la zona: el timer solo toca el DOM. Dentro de la zona, cada uno (uno por
    // imagen) disparaba un ciclo de detección de cambios de toda la app.
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        const originalSrc = this.el.nativeElement.src;

        if (originalSrc && originalSrc.startsWith('http://')) {
          if (!this.shouldKeepHttp(originalSrc)) {
            this.el.nativeElement.src = originalSrc.replace('http://', 'https://');
          }
        }
      }, 0);
    });
  }
}
